import { Pipe, PipeTransform } from '@angular/core';

import { CustomTranslationsService } from '../translations';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateVentilationProgram',
})
export class TranslateVentilationProgramPipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}

  transform(value: string): string {
    if (value && this.customTranslationsService.VENTILATION_PROGRAMS[value]) {
      return this.translateService.instant(
        this.customTranslationsService.VENTILATION_PROGRAMS[value] ?? value
      );
    }

    return value;
  }
}
